// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--1Q_n1"};